// Debug logger - only logs in development mode
const isDebug = process.env.NEXT_PUBLIC_DEBUG === 'true';

export const debugLog = (...args: any[]) => {
  if (isDebug) {
    console.log(...args);
  }
};

export const debugError = (...args: any[]) => {
  if (isDebug) {
    console.error(...args);
  }
};

export const debugWarn = (...args: any[]) => {
  if (isDebug) {
    console.warn(...args);
  }
};
